import { useMemo, useState } from "react";
import { EditOutlined, MinusCircleOutlined, PlusOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button, Card, Select, Space, Tooltip, Form, Input, Modal, Tabs, Table } from "antd";

import { Link, useLocation } from "react-router-dom";
import PageHeader from "../../view/pageheader";
import TableComponent from "../CustomComponents/TableComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  resetSuccessFlag, deleteJob, getJobsList, updateJobStatus, getUsersJobsList,
  getEventDataInJobs,
  deleteJobEvent,
  clearUserJobEventData,

} from "../../store/reducer/jobSlice";
import { getWorkFlowList } from "../../store/reducer/workflowSlice";
import { useEffect } from "react";
import SwalComponent from "../CustomComponents/SwalComponent";
import Swal from "sweetalert2";
import SearchComponent from "../CustomComponents/SearchComponent";
import moment from 'moment-timezone';
import Loader from "../../fields/Loader/Loader";

const Jobs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { jobListData, deleteJobSuccess, jobStatusSuccess, userJosData, deleteJobErrorMessage, deleteJobError, jobLoading } = useSelector((state) => state.jobs);
  const { workflowListData } = useSelector((state) => state.workflow);
  const role_id = localStorage.getItem("role_id");
  const userId = localStorage.getItem("user_id");
  const { count: totalCount, data: tableData } = role_id == 3 ? userJosData : jobListData;
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [workflowData, setWorkflowData] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");
  function getData(payload = {}) {
    if (role_id == 3) {
      // Add userId to payload for role_id == 3
      dispatch(getUsersJobsList({ ...payload, userId }));
      dispatch(clearUserJobEventData());
    } else {
      // dispatch(allocateJobUsers(payload))

      dispatch(getJobsList({ status: status ? status : '', ...payload }));
      dispatch(getWorkFlowList(payload));
    }
  }


  useEffect(() => {
    getData({})
    if (deleteJobSuccess) {
      // toast.success("Job Deleted Successfully");
      dispatch(resetSuccessFlag({ flag: "deleteJobSuccess" }));

    }
    if (deleteJobError) {
      toast.error(deleteJobErrorMessage);
      dispatch(resetSuccessFlag({ flag: "deleteJob" }))

    }

  }, [deleteJobSuccess, deleteJobError, deleteJobErrorMessage, dispatch])

  useEffect(() => {
    if (jobStatusSuccess) {
      toast.success("Job status updated successfully");
      getData();
      dispatch(resetSuccessFlag({ flag: "jobStatusSuccess" }))
    }

  }, [jobStatusSuccess])
  useEffect(() => {
    if (workflowListData?.data) {
      setWorkflowData(workflowListData?.data);
    }
  }, [workflowListData])
  const workflowList = useMemo(() => {
    return workflowData?.filter((item) => item.status == 1).map((data) => {
      return {
        label: data.workflow_name,
        value: data.id,
      };
    })
  }, [workflowData])

  const handleStatusChange = (record, updatedStatus) => {


    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the Job status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateJobStatus({
          postData: { status: updatedStatus, spec: record?.spec_id, volume: record?.volume },
          updateID: record.id
        }));
        // if (updatedStatus == 3) {
        //   dispatch(addJobEvent({ updateID: record.id }))
        // }
        if (updatedStatus == 2) {
          dispatch(deleteJobEvent({ updateID: record.id }))

        }


      }
    });
  }

  const handleWorkflowChange = (record, updatedStatus) => {

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the  Workflow?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!'
    }).then((result) => {
      if (result.isConfirmed) {

        dispatch(updateJobStatus({
          postData: { workflow_id: updatedStatus },
          updateID: record.id
        }));
        // dispatch(updateJob({ postData: data, updateID: editId }));


      }
    });
  }
  const handleAllocateClick = (record) => {
    setSelectedRecord(record);
    dispatch(getEventDataInJobs({ jobId: record?.workflow_id }))
  };
  const columns = [

    {
      title: "Job Name",
      dataIndex: "job_name",
      key: "job_name",
      align: "center",
      sorter: (a, b) => a.job_name.localeCompare(b.job_name),

    },
    {
      title: "Spec ID",
      dataIndex: "spec_id",
      key: "spec_id",
      align: "center",
      sorter: (a, b) => a.spec_id - (b.spec_id),
    },
    {
      title: "Customer",
      dataIndex: 'customer',
      key: "customer",
      align: "center",

      render: data => (
        data?.customername ? data?.customername : "N/A"
      )
    },
    {
      title: "Project Manager",
      dataIndex: "user_role",
      key: "to",
      align: "center",

      render: data => (
        data?.user_name ? data?.user_name : "N/A"


      )
    },
    // {
    //   title: "Assign Workflow",
    //   dataIndex: "workflow_name",
    //   key: "workflow_name",
    //   align: "center",
    //   render: (_, record) => (
    //     <Select
    //       value={record.workflow?.id} // Use workflow ID instead of name for value
    //       onChange={(value) => handleWorkflowChange(record, value)}
    //       style={{ width: 150 }}
    //       options={workflowList} // Directly pass options here
    //       disabled={record?.status > 2}
    //     />
    //   ),
    // },
    {
      title: "Status",
      key: "status",
      align: "center",
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: record.status === 1 ? 'blue' : 'inherit', }}>
          <Select
            value={record.status}
            onChange={(value) => handleStatusChange(record, value)} >
            {/* <Select.Option disabled={record.status > 2 ? true : false} value={1} style={{ color: 'blue' }}>Awaiting Review</Select.Option> */}
            <Select.Option value={2} style={{ color: 'orange' }} disabled={record.status>2}>Yet to Start</Select.Option>
            <Select.Option value={3} style={{ color: 'green' }}>In Progress</Select.Option>
            <Select.Option value={4} style={{ color: 'gray' }}>Completed</Select.Option>
            <Select.Option value={5} style={{ color: 'red' }}>Return to Customer</Select.Option>
          </Select>
        </div>


      )
    },

    {
      title: role_id == 1 || role_id == 2 ? "Action" : "",
      key: "Action",
      align: "center",
      render: data => {
        if (role_id == 1 || role_id == 2) {
          return (
            <Space>
              <Tooltip title="Edit">
                <Button
                  shape="circle"
                  className="border-0"
                  icon={
                    <EditOutlined
                      onClick={() => navigate(`/jobs/edit/${window.btoa(data?.id)}`)}
                      style={{ color: "blue" }}
                    />
                  }
                />
              </Tooltip>
              <Tooltip title="Delete">
                <SwalComponent
                  disabled={data?.status > 2}
                  message="Are you sure you want to delete the Job?"
                  onClickDispatch={deleteJob}
                  id={data?.id}
                />
              </Tooltip>
            </Space>
          );
        }
        return null; // Return null if the condition is not met
      }
    },
    {
      title: role_id == 1 || role_id == 2 ? "Process Boxes" : "",
      key: "Action",
      align: "center",
      render: data => {
        if (role_id == 1 || role_id == 2) {
          return (
            <Space >
              <Tooltip title="View Boxes">
                <Button disabled={data?.status == 2 || data?.status == 1 ? true : false}
                  shape="circle"
                  className="border-0"
                  icon={
                    <ArrowRightOutlined
                      onClick={() => navigate(`/job-dashboard/${window.btoa(data?.id)}`, {
                        state: {
                          job_name: window.btoa(data?.job_name),
                          customer_id: window.btoa(data?.customer_id),
                          workflow_name: window.btoa(data?.workflow?.workflow_name),
                          spec_id: window.btoa(data?.spec_id),
                          workflow_id: window.btoa(data?.workflow?.id)
                        }
                      })}

                      style={{ color: "blue" }}
                    />
                  }
                />
              </Tooltip>

            </Space>
          );
        }
        return null; // Return null if the condition is not met
      }
    }

  ];
  const UserColumns = [

    {


      title: "Job Name",
      dataIndex: "job_name",
      key: "job_name",
      // render: (_, record) => record?.spec_details?.job_name || "N/A",
      align: "center",
      // sorter: (a, b) => a.job_name-(b.job_name),

    },



    {
      title: "Spec",
      dataIndex: "spec_id",
      key: "spec_id",
      // render: (_, record) => record.spec_details?.spec_id,
      align: "center",
      // sorter: (a, b) => a.spec_id-(b.spec_id),
    },
    {
      title: role_id == 3 ? "Action " : "",
      key: "Action",
      align: "center",
      render: data => {
        if (role_id == 3) {
          return (
            <Space>
              <Tooltip title="Edit">
                <Button
                  shape="circle"
                  className="border-0"
                  icon={
                    <PlusOutlined
                      onClick={() => navigate(`/jobs/jobs_event/${window.btoa(data?.id)}`, {
                        state: {
                          job_name: window.btoa(data?.job_name),
                          customer_id: window.btoa(data?.customer_id),
                          workflow_name: window.btoa(data?.workflow?.workflow_name),
                          spec_id: window.btoa(data?.spec_id),
                          workflow_id: window.btoa(data?.workflow?.id)
                        }
                      })}
                      style={{ color: "blue" }}
                    />

                  }
                />
              </Tooltip>

            </Space>
          );
        }
        return null; // Return null if the condition is not met
      }
    }


  ];
  return (
    <div>
      <Loader loading={jobLoading} />
      <PageHeader HeaderText="Job Specs" Breadcrumb={[{ name: "Job Specs" }]} backgroundUrlName={status ? '/dashboard' : null} />
       <Card style={{ marginTop: "-28px", }}
        title="Job Specs"
        extra={
          <>
            <Space size={"middle"} className="my-3">

              <SearchComponent style={role_id != 1 ? { width: "500px" } : { width: "300px" }}
                placeHolder="Search Job Name or Spec ID"
                onChange={e => {
                  const payloadData = {
                    query: e.target.value,
                  };
                  getData(payloadData);
                }} />


            </Space>
            {role_id != 3 && (<>
              <Link to="/jobs/add">
                <Button className="primary-btn ml-2" shape="round">
                  Add Job Spec
                </Button>
              </Link>
            </>)}

          </>
        }
      >
        <TableComponent columns={role_id == 3 ? UserColumns : columns} TotalDataCount={totalCount} dataSource={tableData} size={"small"} onChangeDispatch={getData} />
      </Card>
      {/* {selectedRecord && getEventDataInJobsResponse?.data?.length > 0 && (
        <AllocationModal
          record={selectedRecord}
          eventData={getEventDataInJobsResponse}
          onCancel={() => {
            setSelectedRecord(null);
          }}
        />
      )} */}
    </div>
  );
};

export default Jobs;
